import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { APIURLConstantsService } from '../services/api-url-service/apiurlconstants.service';

import { IFRUtes } from './utes.interfaces';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class UtesService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  private _API_BASE_URL: string = environment['API_URL'];

  public get(primer, quants, filters = {}, conds = {}, ordering = {}): Observable<IFRUtes[]> {
   let params = new HttpParams();
  
    Object.keys(filters)
      .filter(filter => (filters[filter] === 0 || filters[filter]))
      .forEach(filter => params = params.append(filter, filters[filter].toString().replace(/\+/g,"%2B")));

    Object.keys(conds)
      .filter(cond => (conds[cond] === 0 || conds[cond]))
      .forEach(cond => params = params.append(cond, conds[cond].toString()));

    Object.keys(ordering).filter(field => (ordering[field] === 0 || ordering[field]))
    .forEach(field => params = params.append((ordering[field] === 'ASC' ? 'orderAsc' : 'orderDesc'), field));

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }

    return this.authHttp.get<IFRUtes[]>(APIURLConstantsService._API_BASE_URL + 'utes?primer='+primer+'&quants='+quants, this.options)
    .pipe(map(response => {
      return response || [];
    }));
  }

/*  public getUtes(idUte): Observable<IFRUtes[]> {
    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json'
    }
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'utes/' + idUte, this.options)
      .pipe(map(response => response || []));
  }*/

  public createUtes(data): Observable<any> {
    return this.authHttp.post(APIURLConstantsService._API_BASE_URL + 'utes', data)
      .pipe(map(response => response || {}));
  }

  public updateUtes(id, data): Observable<any> {
    return this.authHttp.put(APIURLConstantsService._API_BASE_URL + 'utes/'+id, data)
      .pipe(map(response => response || {}));
  }

 /* public deleteUtes(id): Observable<any> {
    return this.authHttp.delete(APIURLConstantsService._API_BASE_URL + 'utes/'+id)
      .pipe(map(response => response || {}));
  }
*/

  public getCodis(): Observable<any> {
    return this.authHttp.get<any>(this._API_BASE_URL + 'utes/codis/', this.options)
      .pipe(map(response => response || []));
  }

  constructor(private authHttp: HttpClient) { }

}
